import React from 'react';
interface SectionDividerProps {
  /** Background tone the divider sits on, so the line/ornament blend correctly. */
  tone?: 'cream' | 'white';
}
/**
 * A hairline horizontal rule with a centered diamond ornament.
 * Used between sections to give the negative space an intentional, "designed" rhythm.
 */
export function SectionDivider({
  tone = 'cream'
}: SectionDividerProps) {
  const bg = tone === 'white' ? 'bg-white' : 'bg-inkova-cream';
  return <div className={`${bg} flex justify-center`} aria-hidden="true" data-id="element-390">
      <div className="flex items-center gap-5 w-full max-w-[1100px] mx-auto px-6" data-id="element-391">
        <span className="h-[1px] flex-1 bg-gradient-to-r from-transparent to-inkova-border" data-id="element-392" />
        <span className="w-[7px] h-[7px] rotate-45 border border-inkova-primary/40" data-id="element-393" />
        <span className="h-[1px] flex-1 bg-gradient-to-l from-transparent to-inkova-border" data-id="element-394" />
      </div>
    </div>;
}